import { api } from '../api';

// ========== TYPES ==========

export interface LoyaltyTierInfo {
  level: number;
  name: string;
  min_total: number;
  earn_rate: number;
}

export interface LoyaltyLevel {
  current: number;
  name: string;
  earn_rate: number;
  lifetime_total: number;
  current_min: number;
  next_min: number | null;
  next_level: number | null;
  next_name: string | null;
  next_earn_rate: number | null;
  progress_percent: number;
}

export interface LoyaltyBalance {
  balance: number;
  earn_rate: number;
  max_spend_percent: number;
  min_cart_for_spend: number;
  /**
   * От чего сервер считает порог и лимит списания: 'items_plus_delivery' —
   * вместе с доставкой (решение владельца по вопросу 3). Поле новое, старые
   * ответы его не содержат — поэтому необязательное.
   */
  spend_base?: 'items_plus_delivery' | 'items_only';
  /** Срок жизни коинов в месяцах. Применяется в момент начисления. */
  coin_expiry_months?: number;
  level: LoyaltyLevel;
  all_levels: LoyaltyTierInfo[];
}

export interface LoyaltyTransaction {
  id: number;
  type: 'earn' | 'spend' | 'expire';
  amount: number;
  balance_after: number;
  description: string;
  created_at: string;
  expires_at: string | null;
}

export interface LoyaltyHistoryResponse {
  transactions: LoyaltyTransaction[];
  total: number;
}

export interface LoyaltyCalculation {
  balance: number;
  can_spend: boolean;
  max_spend: number;
  discount: number;
  pay_amount: number;
  coins_to_earn: number;
}

// ========== API FUNCTIONS ==========

export async function getLoyaltyBalance(): Promise<LoyaltyBalance> {
  const response = await api.get<LoyaltyBalance>('/loyalty/balance');
  return response.data;
}

export async function getLoyaltyHistory(limit = 20, offset = 0): Promise<LoyaltyHistoryResponse> {
  const response = await api.get<LoyaltyHistoryResponse>('/loyalty/history', {
    params: { limit, offset },
  });
  return response.data;
}

export async function calculateLoyaltyDiscount(
  cartTotal: number,
  useCoins: number,
): Promise<LoyaltyCalculation> {
  const response = await api.post<LoyaltyCalculation>('/loyalty/calculate', {
    cart_total: cartTotal,
    use_coins: useCoins,
  });
  return response.data;
}
